import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { emailScheduleService } from '../../../services/emailScheduleService';

const EmailLogsPanel = ({ onClose }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLogs();
  }, []);

  const loadLogs = async () => {
    try {
      setLoading(true);
      const data = await emailScheduleService?.getEmailLogs();
      setLogs(data || []);
    } catch (error) {
      console.error('Error loading logs:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    return status === 'sent' ? 'text-green-600 bg-green-100' : 'text-red-600 bg-red-100';
  };

  const getReportTypeLabel = (type) => {
    const labels = {
      financial_report: 'Financial Report',
      client_analytics: 'Client Analytics',
      threshold_alerts: 'Threshold Alerts'
    };
    return labels?.[type] || type;
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg shadow-elevation-3 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-2xl font-heading font-bold text-foreground">
            Email Logs
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-smooth press-effect focus-ring"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <div className="p-6">
          {loading ? (
            <div className="flex items-center justify-center py-12">
              <Icon name="Loader2" size={48} className="animate-spin text-primary" />
            </div>
          ) : logs?.length === 0 ? (
            <div className="text-center py-12 text-muted-foreground">
              <Icon name="Mail" size={48} className="mx-auto mb-2 opacity-50" />
              <p>No email logs yet</p>
            </div>
          ) : (
            <div className="space-y-3">
              {logs?.map((log) => (
                <div
                  key={log?.id}
                  className="p-4 bg-background border border-border rounded-lg"
                >
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <h3 className="font-semibold text-foreground">{log?.subject}</h3>
                      <p className="text-sm text-muted-foreground">
                        {getReportTypeLabel(log?.reportType)}
                      </p>
                    </div>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(log?.status)}`}>
                      {log?.status}
                    </span>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <Icon name="Users" size={14} />
                      <span>{log?.recipients?.length || 0} recipients</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Calendar" size={14} />
                      <span>{new Date(log?.sentAt)?.toLocaleString()}</span>
                    </div>
                  </div>
                  {log?.errorMessage && (
                    <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded text-sm text-red-600">
                      <Icon name="AlertCircle" size={14} className="inline mr-1" />
                      {log?.errorMessage}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailLogsPanel;